export const WEBYES_SCAN_BASE_URL = "https://accessibility.webyes.com/accessibility/scan";
export const WEBYES_CONSULTATION_URL = "https://www.webyes.com/free-accessibility-consulting?utm_medium=consulation_banner&utm_source=wordpress_plugin&utm_campaign=accessiyes";
